












import Vue, { PropOptions } from 'vue';

type FaqProps = Blok & {
  title: string;
  faqRows: Blok[];
};

export default Vue.extend({
  props: {
    blok: {
      type: Object,
      required: true,
    } as PropOptions<FaqProps>,
  },
});
